import {Button, Container, Description, Form, Highlight} from "../SharedStyles";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";


const RequestLogin = () => {
  const navigate = useNavigate();
  const email = useSelector((state) => state.user.email);

  const handleRequest = (e) => {
    e.preventDefault();
    //TODO send login request to backend
    navigate('/login/requested')
  };

  return (
    <Container>
      <Form onSubmit={handleRequest}>
        <Description>An account with <Highlight>{email}</Highlight> already exists.</Description>
        <Description>Would you like to request a password reset?</Description>
        <Button type="submit">Request Password Reset</Button>
      </Form>
    </Container>
  );
};

export default RequestLogin;